<div class="load-error-content">
  <h2 class="text-center">{{ 'load-error.title' | translate }}</h2>

  <p class="body-16 text-center">{{ messageKey | translate }}</p>

  <button class="button primary" [disabled]="retrying" (click)="retry()">
    {{ (retrying ? 'load-error.retrying-button' : 'load-error.retry-button') | translate }}
  </button>
</div>
